import React, { useEffect, useContext } from 'react';

import ResultsComponent from '../../../../components/ResultsComponent';

import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { DilutionStrengthDilutedContext } from '../../../../contexts/DilutionProvider/DilutionStrengthDilutedProvider';
import { ResultsContext } from '../../../../contexts/ResultsProvider';

interface DilutionStrengthDilutedResultScreenProps {
 description?: string;
}

function DilutionStrengthDilutedResultScreen({
 description,
}: DilutionStrengthDilutedResultScreenProps): React.ReactElement {
 const {
  setNextButtonAction,
  setNextButtonText,
  setBackButtonText,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const { thirdScreenRedirect, homeRedirect } = useContext(
  DilutionStrengthDilutedContext,
 );

 const { setHasMultipleResults } = useContext(ResultsContext);

 const setNavigationProps = () => {
  const setNextButtonProps = () => {
   setNextButtonAction(homeRedirect);
   setNextButtonText('Ferdig');
  };
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(thirdScreenRedirect);
  };
  setNextButtonProps();
  setBackButtonProps();
 };

 useEffect(() => {
  setNavigationProps();
  setHasMultipleResults(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return <ResultsComponent description={description} />;
}

DilutionStrengthDilutedResultScreen.defaultProps = {
 description: 'Styrke, fortynnet',
};

export default DilutionStrengthDilutedResultScreen;
